export default "__VITE_ASSET__tl6O7czT__"